module.exports = __webpack_public_path__ + "static/media/close.5fb65399.svg";